import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import SupportTemplatePageUI from './SupportTemplatePageUI.js'

class SupportTemplatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      rootTemplate: null,
      flattenedTemplates: [],
    }
  }

  render() {
    return (
      <SupportTemplatePageUI
        context={this.props.context}
        rootTemplate={this.state.rootTemplate}
        templateList={this.state.flattenedTemplates}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTemplates(context)
  }

  getTemplates(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/support/templates`,
      cacheKey: CacheKeys.SupportTemplates(),
      callback: this.getTemplatesCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getTemplatesCallback = (response) => {

    const flattenedTemplates = this.flattenTree(response.supportTemplate)

    this.setState({ rootTemplate: response.supportTemplate, flattenedTemplates: flattenedTemplates })
  }

  flattenTree(rootTemplate) {
    let flatList = [];

    function flatten(node) {
      flatList.push({
        key: node.supportTemplateId,
        value: node.title,
        // Add other key-value pairs as needed
      });

      if (node.supportTemplateList && node.supportTemplateList.length > 0) {
        node.supportTemplateList.forEach(supportTemplate => flatten(supportTemplate));
      }
    }

    rootTemplate && rootTemplate.supportTemplateList &&
      rootTemplate.supportTemplateList.forEach(supportTemplate => flatten(supportTemplate));

    return flatList;
  }



  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.SupportTemplates())
    if (noBusy === 'noBusy') {
      this.getTemplates(context)
    }
    else {
      this.setState({ rootTemplate: null, flattenedTemplates: [] }, () => {
        this.getTemplates(context)
      })
    }
  }
}

export default withRouter(SupportTemplatePageSF)
